// a place for stateless functions

import lodash from './lodash'
import {DRAFT_TEXT, PUBLISHED_TEXT, ARCHIVED_TEXT, LOADING_PRISTINE} from "./constants"

//takes an entry
function getPrimaryDisplayName(entry) {

    let displayText = null
    if (entry) {
        const identifier = getPrimaryDisplayIdentifier(entry.contentType);
        entry.fields.forEach(field => {
            if (field.identifier === identifier) {
                displayText = field.value;
            }
        })
    }
    if (!displayText) {
        return 'Primary display field not found'
    }
    return displayText
}

// takes a content type
function getPrimaryDisplayIdentifier(contentType) {
    let primaryIdentifier = null
    if (contentType) {
        contentType.fields.forEach(fieldMetadata => {
            if (fieldMetadata.primaryDisplay) {
                primaryIdentifier = fieldMetadata.identifier
            }
        })
    }
    if (!primaryIdentifier) {
        return 'Primary identifier not found'
    }
    return primaryIdentifier

}

//takes an entry
function getDisplayNameByIdentifier(entry, identifier) {
    let displayText = null
    if (entry && entry.fields) {
        entry.fields.forEach(field => {
            if (field.identifier === identifier) {
                displayText = field.value;
            }
        })
    }
    return displayText
}

// takes a content type
function getNameByIdentifier(contentType, identifier) {
    let name = null
    if (contentType) {
        contentType.fields.forEach(fieldMetadata => {
            if (fieldMetadata.identifier === identifier) {
                name = fieldMetadata.name
            }
        })
    }
    return name

}

//takes an entry
function searchEntries(entries, searchTerm) {
    if (searchTerm === '' || searchTerm === null) {
        return entries.slice()
    } else {
        return entries.filter(entry => {
            const identifier = getPrimaryDisplayIdentifier(entry.contentType);
            const primaryDisplayField = entry.fields.find(field => {
                return field.identifier === identifier
            })
            return primaryDisplayField.value.toLowerCase().includes(searchTerm.toLowerCase())
        })
    }
}

function filterEntriesByReferenceEntries(entries, referenceEntries) {
    return entries.filter(entry => {
        const referenceFilterEntriesArr = referenceEntries
        if (referenceFilterEntriesArr.length === 0) {
            return true
        }
        return referenceFilterEntriesArr.every(referenceEntry => {
            const refField = entry.fields.find(field => {
                return field.referenceType === referenceEntry.contentType.identifier
            })
            if (refField) {
                return Number(refField.value) === referenceEntry.id
            }
            return false
        })
    })
}


// takes a field
function castField(field) {
    if (field.allowsMultiple && Array.isArray(field.value)) {
        return field.value.map(eachValue => {
            return castField(eachValue)
        })
    } else {
        switch (field.type) {
            case 'boolean':
                return field.value === 'true'
            case 'number':
                return Number(field.value)
            case 'reference':
                return Number(field.value)
            default:
                return field.value
        }
    }
}

function getFieldOfEntryByName(entry, fieldName) {
    const result = entry.fields.find(field => {
        return field.identifier === fieldName
    })
    if (result) {
        return result.value
    }
    return `${fieldName} not found`
}

// takes an entry of contentType 'asset'
function getMediaTypeOfEntry(entry, storeState) {
    const mimeType = entry.fields.find(field => {
        return field.identifier === 'media_type'
    }).value
    const supportedMimeType = storeState.media.mediaTypes.find(mediaType => {
        return mediaType.mimeType === mimeType
    })
    if (supportedMimeType) {
        return supportedMimeType
    } else {
        return {
            mimeType: mimeType,
            category: mimeType,
            displayName: null,
        }
    }
}

//takes a status
function cssComputeStatusColor(status) {
    switch (status.toLowerCase()) {
        case DRAFT_TEXT.toLowerCase():
            return 'status-draft-color'
        case PUBLISHED_TEXT.toLowerCase():
            return 'status-published-color'
        case ARCHIVED_TEXT.toLowerCase():
            return 'status-archived-color'
        default:
            return 'status-draft-color'
    }
}

//takes a location
function locationToLatLongString(location) {
    return `${location.lat},${location.lng}`
    // return `${Math.round(location.lat * 100) / 100},${Math.round(location.lng * 100) / 100}`
}

function latLongStringToLocation(latLongString) {
    const arr = latLongString.split(',')
    if (arr.length === 2) {
        return {
            lat: Number(arr[0]),
            lng: Number(arr[1])
        }
    } else {
        return null
    }
}

function excludeMediaFields(field) {
    return field.identifier !== 'url'
        && field.identifier !== 'media_type'
        && field.identifier !== 'size'
        && field.identifier !== 'height'
        && field.identifier !== 'width'
        && field.identifier !== 'duration'
}

function excludeFieldsWithServiceValidation(field) {
    return !field.validations.some(validation => {
        return validation.name === 'system'
    })
}


function includeMediaFields(field) {
    return !excludeMediaFields(field)
}

function isFieldANonAssetReferenceField(field) {
    return field.type === 'reference' && field.referenceType && field.referenceType !== 'asset'
}

function buildIncomingObj(data) {
    const fieldsSnapshot = lodash.cloneDeep(data.fields)
    data.fields = data.fields.map(field => {
        if (field.allowsMultiple) {
            field.value = fieldsSnapshot.filter(snapShotField => {
                return snapShotField.allowsMultiple && snapShotField.identifier === field.identifier
            })
        }
        return field
    }).filter((elem, pos, arr) => {
        return arr.findIndex(elem2 => {
            return elem2.identifier === elem.identifier
        }) === pos
    });
    return data
}

function buildOutgoingObj(data) {
    const flatFields = []
    data.fields.forEach(field => {
        if (Array.isArray(field.value)) {
            field.value.forEach(subValue => {
                if (subValue !== '') {
                    flatFields.push({
                        identifier: field.identifier,
                        value: subValue,
                    })
                }
            })
        } else {
            flatFields.push(field)
        }
    })
    data.fields = flatFields
    return data
}

// takes a vue route object
function isEditRoute(route) {
    return route.name === 'spaceDashboardEditEntry'
        || route.name === 'spaceDashboardEditEntryLocale'
        || route.name === 'spaceDashboardEditMedia'
}

function orderedEntrySort(entryA, entryB) {
    const orderFieldA = findOrderedField(entryA)
    const orderFieldB = findOrderedField(entryB)
    if (orderFieldA && orderFieldB) {
        const numA = Number(orderFieldA.value)
        const numB = Number(orderFieldB.value)
        if (numA < numB) {
            return -1
        }
        if (numA > numB) {
            return 1
        }
    } else if (orderFieldA) {
        //    orderFieldB is null
        return -1
    } else if (orderFieldB) {
        //    orderFieldA is null
        return 1
    }
    return 0
}

function findOrderedFieldDefinition(entry) {
    const fieldOfContentTypeOfEntry = entry.contentType.fields.find(field => {
        let isOrdered = false
        field.validations.forEach(validation => {
            if (validation.name === 'system' && validation.value === 'order') {
                isOrdered = true
            }
        })
        return isOrdered
    })
    if (fieldOfContentTypeOfEntry) {
        return fieldOfContentTypeOfEntry
    }
    return null
}

function findOrderedField(entry) {
    const fieldOfContentTypeOfEntry = findOrderedFieldDefinition(entry)
    if (fieldOfContentTypeOfEntry) {
        const orderFieldOrNull = entry.fields.find(field => {
            return field.identifier === fieldOfContentTypeOfEntry.identifier
        })
        if (orderFieldOrNull) {
            return orderFieldOrNull
        }
    }
    return null
}

const asyncArrayConstructor = () => {
    return {
        loadingState: LOADING_PRISTINE,
        data: [],
        error: null
    }
}

const asyncObjectConstructor = () => {
    return {
        loadingState: LOADING_PRISTINE,
        data: null,
        error: null
    }
}

const mediaRefConstructor = () => {
    return {
        state: LOADING_PRISTINE,
        fileRef: null,
        progress: 0,
    }
}

const convertToOutgoingEntry = (internalEntry, optionalId, optionalStatus) => {
    const outgoingObj = {
        id: -1,
        fields: [],
        status: ''
    }
    if (optionalId) {
        outgoingObj.id = optionalId
    }

    if (optionalStatus) {
        outgoingObj.status = optionalStatus
    }
    for (const key of Object.keys(internalEntry)) {
        const field = {
            identifier: key,
            value: internalEntry[key].value
        }
        outgoingObj.fields.push(field)
    }
    return outgoingObj
}


const Helpers = {
    getNameByIdentifier: getNameByIdentifier,
    getDisplayNameByIdentifier: getDisplayNameByIdentifier,
    getPrimaryDisplayName: getPrimaryDisplayName,
    getPrimaryDisplayIdentifier: getPrimaryDisplayIdentifier,
    searchEntries: searchEntries,
    filterEntriesByReferenceEntries: filterEntriesByReferenceEntries,
    castField: castField,
    getFieldOfEntryByName: getFieldOfEntryByName,
    getMediaTypeOfEntry: getMediaTypeOfEntry,
    cssComputeStatusColor: cssComputeStatusColor,
    locationToLatLongString: locationToLatLongString,
    latLongStringToLocation: latLongStringToLocation,
    excludeMediaFields: excludeMediaFields,
    includeMediaFields: includeMediaFields,
    excludeFieldsWithServiceValidation: excludeFieldsWithServiceValidation,
    isFieldANonAssetReferenceField: isFieldANonAssetReferenceField,
    buildIncomingObj: buildIncomingObj,
    buildOutgoingObj: buildOutgoingObj,
    isEditRoute: isEditRoute,
    orderedEntrySort: orderedEntrySort,
    findOrderedFieldDefinition: findOrderedFieldDefinition,
    findOrderedField: findOrderedField,
    asyncArrayConstructor,
};

export {convertToOutgoingEntry, asyncObjectConstructor, mediaRefConstructor, asyncArrayConstructor}
export default Helpers

